<template>
  <div id="app">
    <klickpages-header
      :klickartURL="klickartURL"
      :jwtSecret="jwtSecret"
      :hotmartURL="hotmartURL"
    />
    <router-view></router-view>
    <klickpages-support-chat :klickartURL="klickartURL" />
  </div>
</template>

<script>
import User from './services/request/user';

const UserRequest = new User();

export default {
  name: 'app',
  data() {
    return {
      hotmartURL: process.env.HOTMART_URL,
      klickartURL: process.env.KLICKART_URL.replace('http:', 'https:'),
      jwtSecret: process.env.KLICKPAGES_HEADER_JWT_SECRET,
    };
  },
  mounted() {
    if (!this.$router.currentRoute.fullPath.match('logout')) {
      UserRequest.identifier()
        .then((response) => {
          this.$ga.set('userId', response.data);
          this.$ga.page(this.$router);
        });
    }
  },
};
</script>

<style lang="scss">
@import './assets/scss/main';
</style>



// WEBPACK FOOTER //
// App.vue?66d8ced1